import CategoryDetail from './Main'
import { getBaseMetaTitle } from '@/environments'

const route = {
  path: '/awards/:id',
  name: 'category-detail',
  component: CategoryDetail,
  meta: {
    title: `Awards - ${getBaseMetaTitle}`
  }
}

export default route
